import { GearProxyService } from 'common-gear';
import { AppService, CoreProxyService } from 'common-cloudstudio';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.scss']
})
export class PanelComponent implements OnInit {
  @Input()
  opened = true;
  @Input()
  title: string;
  @Input()
  titleFirts: boolean = false;
  @Input()
  id:string;
  @Output()
  toggle: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public _appService: AppService,
    private _coreProxyService: CoreProxyService,
    private _gearProxyService: GearProxyService
  ) {}

  ngOnInit() {}
}
